
    <button mat-icon-button
            color="primary"
            *ngIf="comment || !readOnly"
            (click)="openPopup()"
            matTooltip="{{comment ? 'Read comment' : 'Write new comment'}}">
      <i class="fas fa-comment" *ngIf="comment" aria-hidden="true"></i>
      <i class="far fa-comment" *ngIf="!comment" aria-hidden="true"></i>
      <!--<span class="d-md-none">Read comment</span>-->
    </button>
  